
import React from 'react';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

interface IncomeSliderProps {
  value: number[];
  onChange: (value: number[]) => void;
}

const IncomeSlider: React.FC<IncomeSliderProps> = ({ value, onChange }) => {
  const formatIncome = (value: number) => {
    if (value < 100000) return `₹${Math.round(value / 1000)}K`;
    return `₹${(value / 100000).toFixed(1)}L`;
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Label htmlFor="monthlyIncome">Monthly Income Range</Label>
        <span className="text-[#9E7C47] text-sm">
          {formatIncome(value[0])}
        </span>
      </div>
      
      <Slider
        id="monthlyIncome"
        defaultValue={[50000]}
        max={500000}
        step={5000}
        value={value}
        onValueChange={onChange}
        className="py-4"
      />
      
      <div className="flex justify-between text-xs text-white/50 mt-1">
        <span>₹10K</span>
        <span>₹50K</span>
        <span>₹1L</span>
        <span>₹5L+</span>
      </div>
    </div>
  );
};

export default IncomeSlider;
